<script setup>
import Offcanvas from 'bootstrap/js/dist/offcanvas'
import Menu from "@/components/Menu"
import { onMounted, onUnmounted, defineProps, defineEmits, ref } from "vue"
import { useRouter } from "vue-router"

const emits = defineEmits(['open-profile'])

const isMobile = ref(window.innerWidth < 765)

let offcanvasInstance = null

const props = defineProps({
  reloadMenu: {
    type: Boolean
  },
  userStore: {
    type: Object,
    default: Object
  }
})

onMounted(() => {
  document.querySelectorAll('.offcanvas').forEach(el => new Offcanvas(el))

  const el = document.getElementById('offcanvasMenu')
  if (el) {
    offcanvasInstance = Offcanvas.getOrCreateInstance(el)
  }

  const router = useRouter()

  const closeMenuHook = router.afterEach(() => {
    if (offcanvasInstance?.hide) {
      offcanvasInstance.hide()
    }
  })

  window.addEventListener('resize', () => {
    isMobile.value = window.innerWidth < 765
  })

  // Clean up on unmount
  onUnmounted(() => {
    closeMenuHook() // remove afterEach listener
  })
})

</script>

<template>
  <!-- Mobile Top Bar -->
  <div class="top-bar d-flex justify-content-between align-items-center px-3 d-md-none" v-if="isMobile">

    <div class="logo-mobile"></div>

    <i class="bi bi-list text-white fs-1" data-bs-toggle="offcanvas"
      data-bs-target="#offcanvasMenu"></i>
  </div>

  <!-- Offcanvas Menu -->
  <div class="bootstrap-scope" v-if="isMobile">
    <div class="offcanvas offcanvas-start custom-offcanvas bg-black" tabindex="-1" id="offcanvasMenu">
      <div class="offcanvas-header position-absolute end-0">
        <i
          class="bi bi-x fs-1 text-white position-absolute end-0"
          data-bs-dismiss="offcanvas"
        ></i>
      </div>

      <div class="offcanvas-body custom-offcanvas-body">
        <Menu :key="props['reload-menu']" @open-profile="emits('open-profile')" :is-mobile="true" :user-store="props.userStore"/>
      </div>
    </div>
  </div>

  <!-- Desktop Menu -->
  <div class="menu-container d-none d-md-flex" v-if="!isMobile">
    <Menu :key="props['reload-menu']" @open-profile="emits('open-profile')" :is-mobile="false" :user-store="props.userStore"/>
  </div>
</template>

<style scoped>
/* Mobile Top Bar */
.top-bar {
  height: 50px;
  background-color: #000;
  color: #fff;
  z-index: 1050;
  position: sticky;
  top: 0;
}

.logo-mobile {
  background-image: url("../../images/logo-mobile.png");
  height: 33px;
  width: 100px;
  background-repeat: no-repeat;
  background-size: contain;
}

.custom-offcanvas {
  --bs-offcanvas-width: 270px;
  top: 0 !important;
  height: 100vh !important;
  z-index: 1051;
}

.offcanvas-header {
  height: 50px;
  position: sticky;
  top: 0;
  background-color: #000;
  z-index: 1;
}

.offcanvas.offcanvas-start {
  --bs-offcanvas-width: 230px;
}

.custom-offcanvas-body {
  overflow-y: hidden;
  height: calc(100vh - 50px);
  --bs-offcanvas-padding-x: .5rem;
  --bs-offcanvas-padding-y: .5rem;
}

</style>
